import React from 'react';
import SolutionDepositWaitContainer from 'containers/SolutionDepositWaitContainer';

export default function SolutionDepositWaitPage() {
  return (
    <SolutionDepositWaitContainer />
  )
}
